angular
  .module 'shared'
  .factory 'EzidebitService', () ->
    getCustomerReference: (params) ->
      rnd = Math.floor(Math.random() * 10000000000)
      "#{params.gymId}-#{params.context}-#{params.contactId || 'NEW'}-#{moment().unix()}-#{rnd}"

    transliterate: (str) ->
      return '' unless str
      str.normalize('NFD').replace(new RegExp('[\\u0300-\\u036f]', 'gu'), '').replace(new RegExp('[^\\x00-\\x7F]', 'gu'), '?')
